import { configureStore } from '@reduxjs/toolkit';
import authSignInSlice from '../../pages/AuthSignIn/AuthSignInSlice';
import dashboardSlice from '../../pages/Dashboard/DashboardSlice';

import profileSlice from '../../pages/Profile/ProfileSlice';
import deviceSlice from '../../pages/Device/DeviceSlice';
import customersSlice from '../../pages/Customers/CustomersSlice';
import customerUsersSlice from '../../pages/CustomerUsers/CustomerUsersSlice';
import attributeSlice from "../../pages/Attribute/AttributeSlice";
import documentSlice from "../../pages/Document/DocumentSlice"

export const store = configureStore({
  reducer: {
    auth: authSignInSlice,
    profile: profileSlice,
    device: deviceSlice,
    customers: customersSlice,
    dashboard: dashboardSlice,
    customerUsers: customerUsersSlice,
    attribute: attributeSlice,
    document: documentSlice
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});
